import { eTipoPermissao } from '@/enums/ePermissoes';

export default[
    {
        description: 'Cadastro de turnos',
        path: '/academico/parametros/turnos',
        name: 'turno',
        component: () => import('@/views/academico/parametros/turnos/Cadastro/Index.vue'),
        meta: {
          permissions: [
              eTipoPermissao.NOVO_TURNOS_MENU_300900501           
          ]
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de turnos',
        path: '/academico/parametros/turnos/cadastro/:id?',
        parent: 'cadastroTurnos',
        name: 'cadastroTurnos_create',
        component: () => import('@/views/academico/parametros/turnos/Cadastro/InclusaoEdicao.vue'),
        meta: {
          permissions: [
             eTipoPermissao.NOVO_TURNOS_MENU_300900501
           ]
        },
        goesToMenu: true,
    }
]